module.exports = "<div><ul tabindex = \"0\" data-dojo-attach-point= \"containerNode, focusNode\"></ul></div>"